//@ts-check
import { forwardRef } from 'react';

import { useActionStep } from '../hooks/useActionStep';

const SplunkAPLogsStep = forwardRef(
  /**
   * @param {{
   *  onSuccess?: () => void,
   *  onFail?: () => void,
   * }} props
   * @param {React.Ref<any>} ref
   */
  ({ onSuccess, onFail }, ref) => {
    return useActionStep(ref, {
      onFail,
      onSuccess,
      name: "Splunk AP logs",
      action: "check-ap-logs",
      data: {},
      onResponse: (data, log) => {
        if (data.logs.length === 0) {
          log.fatal(`No data found in Splunk for the last 24 hours`);
          return false;
        }

        // Sort logs by time in ascending order
        data.logs.sort((a, b) => new Date(a.time).getTime() - new Date(b.time).getTime());

        log.info(
          `Found ${data.logs.length} logs in Splunk for the last 24 hours`
        );

        for (let index = 0; index < data.logs.length; index++) {
          const logItem = data.logs[index];

          log.info(`${logItem.time}: ${logItem.nodeName} - ${logItem.msg}`);
        }
      },
    });
  }
);

export default SplunkAPLogsStep;
